import controller from './billAtTable.controller';
import template from './billAtTable.html';

const BillAtTableDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default BillAtTableDetailsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/billAtTable/billAtTable.component.js
 **/